<template>
  <SuccessButton
    type="button"
    class="bulk-add-record-collection"
    data-dd="Bulk Edit: Add New Record Collection"
    @click="handleAddRecordCollection"
  >
    + Add New Record Collection
  </SuccessButton>
</template>

<script setup>
import SuccessButton from "@/components/CMSComponents/Buttons/SuccessButton.vue";
import { addRecordCollection } from "@/components/CMSComponents/Records/addRecordCollectionHelper.ts";
import { useStore } from "vuex";

const props = defineProps({
  gridApi: { type: [Object, null], default: null },
  numberOfRows: {
    type: Number,
    default: 0,
  },
});

const store = useStore();

const scrollToBottom = () =>
  props.gridApi?.ensureIndexVisible(props.numberOfRows - 1);
const handleAddRecordCollection = async () => {
  await addRecordCollection(store);
  scrollToBottom();
};
</script>

<style scoped>
.bulk-add-record-collection {
  height: 35px;
  width: 250px;
  background-color: #51bd96;
  border: none;
  font-size: 13px;
}
.bulk-add-record-collection:hover {
  background-color: white;
  color: #51bd96;
  border: 1px solid #51bd96;
}
</style>
